import { CsvSettingsApiService } from '../../../shared/services/api';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { SiDialogComponent } from '../../../shared/components';
import { Observable } from 'rxjs';
import { LoadingService } from '../../../shared/services';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

const LOADING_TAG: string = 'csv-settings-modal-loading-tag';

@UntilDestroy()
@Component({
    selector: 'app-csv-settings',
    templateUrl: './csv-settings-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CsvSettingsModalComponent implements OnInit {
    readonly isLoading$: Observable<boolean> = this.loadingService.getIsLoading(LOADING_TAG);

    csvsettings: FormGroup;
    csvSettingDataOfUser = {
        exportStateAsAbbreviation: false,
        exportCountryAsAbbreviation: false,
        exportRevenue: false,
        exportEmployeeCount: false
    };
    csvDataFromAPI: any;

    constructor(
        private authenticationService: AuthenticationService,
        private csvSettingsApiService: CsvSettingsApiService,
        private formBuilder: FormBuilder,
        private readonly loadingService: LoadingService,
    ) {
        this.csvsettings = this.formBuilder.group({
            exportStateAsAbbreviation: this.csvSettingDataOfUser.exportStateAsAbbreviation,
            exportCountryAsAbbreviation: this.csvSettingDataOfUser.exportCountryAsAbbreviation,
            exportEmployeeCount: this.csvSettingDataOfUser.exportEmployeeCount,
            exportRevenue: this.csvSettingDataOfUser.exportRevenue
        });
    }

    ngOnInit() {
        this.getCsvSettings();
    }

    getCsvSettings() {
        this.authenticationService.currentUser$.subscribe((data) => {
            this.csvDataFromAPI = data;
            this.csvSettingDataOfUser = {
                exportStateAsAbbreviation: (data['user_meta'].csvExportStateAsAbbreviation === '0' ? false : true),
                exportCountryAsAbbreviation: (data['user_meta'].csvExportCountryAsAbbreviation === '0' ? false : true),
                exportRevenue: (data['user_meta'].csvExportRevenue === '0' ? false : true),
                exportEmployeeCount: (data['user_meta'].csvExportEmployeeCount === '0' ? false : true)
            };
            this.csvsettings.patchValue(this.csvSettingDataOfUser);
        });
    }

    saveSettings(dialog: SiDialogComponent) {
        const formData = this.csvsettings.value;
        const data = {
            csvExportEmployeeCount: (formData.exportEmployeeCount === false ? '0' : '1'),
            csvExportRevenue: (formData.exportRevenue === false ? '0' : '1'),
            csvExportStateAsAbbreviation: (formData.exportStateAsAbbreviation === false ? '0' : '1'),
            csvExportCountryAsAbbreviation: (formData.exportCountryAsAbbreviation === false ? '0' : '1')
        };
        this.saveCSVSettings(data).pipe(untilDestroyed(this)).subscribe(() => {
            this.csvDataFromAPI['user_meta'].csvExportEmployeeCount = data.csvExportEmployeeCount;
            this.csvDataFromAPI['user_meta'].csvExportRevenue = data.csvExportRevenue;
            this.csvDataFromAPI['user_meta'].csvExportStateAsAbbreviation = data.csvExportStateAsAbbreviation;
            this.csvDataFromAPI['user_meta'].csvExportCountryAsAbbreviation = data.csvExportCountryAsAbbreviation;

            this.authenticationService.setUser(this.csvDataFromAPI);
            dialog.onClose();
        });
    }

    saveCSVSettings(data) {
        return this.loadingService.loadingWrapper(this.csvSettingsApiService.saveCSVSettings(data), LOADING_TAG);
    }
}
